/**
 * LE VOCABULAIRE DES LOOKS, ET LE REGISTRE DE CEUX QUI SONT DESSINES.
 *
 * DEUX LISTES, ET C'EST VOULU. `LOOKS` est le vocabulaire : la copie exacte, dans le meme ordre,
 * de `Altores::ConfigWidget::LOOKS` cote serveur, et une garde par lecture de source refuse que
 * les deux divergent. Le registre, lui, ne contient que les looks REELLEMENT dessines : les neuf
 * y sont depuis le lot D, `mesure` (le dessin sur mesure d'un client) les a rejoints, et `aucun`
 * n'y sera jamais, puisque c'est l'absence de look.
 *
 * UN MOT SANS FEUILLE NE SE REND PAS EN SILENCE. Les deux listes sont a jour l'une de l'autre
 * aujourd'hui ; elles divergeront le jour ou le serveur d'un client aura pris un mot que son SDK
 * en cache ne connait pas encore. Le SDK tourne sur la page du client : rendre « presque » le
 * look demande serait le pire des deux mondes. Le lanceur retombe sur la bulle d'aujourd'hui —
 * la bulle du client, pas une approximation — et le dit dans la console.
 */
import aurore from './aurore';
import bouche from './bouche';
import braise from './braise';
import encre from './encre';
import iris from './iris';
import mesure from './mesure';
import orbe from './orbe';
import phare from './phare';
import trait from './trait';
import vitre from './vitre';

export const LOOKS = [
  'aucun',
  'orbe',
  'bouche',
  'trait',
  'vitre',
  'aurore',
  'encre',
  'braise',
  'iris',
  'phare',
  'mesure',
];

const REGISTRE = {
  aurore,
  bouche,
  braise,
  encre,
  iris,
  mesure,
  orbe,
  phare,
  trait,
  vitre,
};

export const lookParId = id => REGISTRE[id] || null;
